import React, { useEffect, useState } from 'react';
import { useBreakPoints, themeColor } from '../../Theming';
import { Hamburger, Close } from '../../Common/Svg/Icons';
import styled, { createGlobalStyle } from 'styled-components';
import UnstyledButton from '../../Common/Buttons/UnstyledButton';
import MenuBody from './MenuBody';
import { useLocation, Link } from 'react-router-dom';
import KindredSDKLogo from '../../Common/Svg/Logos/KindredSDKLogo';
import { Path } from '../../Routing';
import { useTranslation } from 'react-i18next';

const NoScrollOnBody = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

const HamburgerButton = styled(UnstyledButton)`
  padding: 0;
  grid-column: 2 / 3;
  justify-self: flex-end;
`;

const CloseButton = styled(UnstyledButton)`
  grid-column: 1 / 1;
  padding: 0;
  justify-self: flex-end;
  width: 24px;
  height: 24px;
`;

const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${themeColor('white')};
  z-index: 100;
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  grid-template-rows: 65px 1fr;
  align-items: center;
`;

const ImageLink = styled(Link)`
  grid-area: 1 / 2 / 2 / 3;
  justify-self: center;
`;

const MenuBodyContainer = styled.div`
  grid-area: 2 / 1 / 3 / 4;
  padding-bottom: 20px;
  overflow-y: auto;
  align-self: stretch;
  justify-self: stretch;
`;

const LogoContainer = styled.h1`
  justify-self: center;
`;

const StyledLogo = styled(KindredSDKLogo)`
  width: auto;
  height: 22px;
`;

const HamburgerMenu: React.FC = () => {
  const { mobile } = useBreakPoints();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!mobile) {
      setIsOpen(false);
    }
  }, [mobile]);

  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <>
      <HamburgerButton
        onClick={() => setIsOpen(true)}
        aria-label={t('navigation.showMenu')}
      >
        <Hamburger />
      </HamburgerButton>
      {isOpen && (
        <MenuContainer>
          <NoScrollOnBody />
          <CloseButton
            onClick={() => setIsOpen(false)}
            aria-label={t('navigation.hideMenu')}
          >
            <Close width={14} height={14} />
          </CloseButton>
          <LogoContainer>
            <ImageLink to={Path.Home}>
              <StyledLogo />
            </ImageLink>
          </LogoContainer>
          <MenuBodyContainer>
            <MenuBody />
          </MenuBodyContainer>
        </MenuContainer>
      )}
    </>
  );
};

export default HamburgerMenu;
